// watermark.service.ts
import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';

@Injectable({
  providedIn: 'root'
})
export class WatermarkService {
  addWatermark(doc: jsPDF, imgSrc: string, pageWidth: number, pageHeight: number): Promise<void> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imgSrc;

      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          if (ctx) {
            // Aumentar la resolución del canvas (2x el tamaño deseado)
            canvas.width = 300;  // 150 * 2
            canvas.height = 600; // 300 * 2

            // Mejorar la calidad del renderizado
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';

            // Limpiar el canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Dibujar imagen con opacidad
            ctx.globalAlpha = 0.1;
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            // Convertir a escala de grises
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            for (let i = 0; i < data.length; i += 4) {
              const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
              data[i] = avg;     // Red
              data[i + 1] = avg; // Green
              data[i + 2] = avg; // Blue
            }
            ctx.putImageData(imageData, 0, 0);

            // Convertir a base64 con alta calidad
            const watermarkBase64 = canvas.toDataURL('image/png', 1.0);

            // Agregar la marca de agua al PDF
            const imgWidth = 180;
            const imgHeight = 180; // Ajustar la altura
            doc.addImage(watermarkBase64, 'PNG', (pageWidth - imgWidth) / 2, (pageHeight - imgHeight) / 2, imgWidth, imgHeight);

            resolve();
          } else {
            reject(new Error('No se pudo obtener el contexto del canvas'));
          }
        } catch (error) {
          reject(error);
        }
      };

      img.onerror = () => {
        reject(new Error('No se pudo cargar la imagen'));
      };
    });
  }
}
